import * as actions from "../constants/actionTypes";
export const INITIAL_STATE = {
    notifications: { list: [] },
    hasMore: true,
};
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.GET_NOTIFICATION_LIST_SUCCESS:
            // const { name } = action.payload;
            localStorage.setItem("loadMoreLayout",false);
            return {
                ...state,
                notifications: action.payload.notifications.list != undefined ?
                    action.payload.newData ?
                        action.payload.notifications :
                        { ...action.payload.notifications, list: [...state.notifications.list, ...action.payload.notifications.list] }
                    : state.notifications,
                hasMore: action.payload.notifications.list != undefined ?
                    action.payload.newData ?
                        action.payload.notifications.list.length < action.payload.notifications.totalRecords[0].count
                        : state.notifications.list.length + action.payload.notifications.list.length < action.payload.notifications.totalRecords[0].count : false,
            }

        case actions.NOTIFICATION_MARK_AS_READ_SUCCESS:
            let notifications = { ...state.notifications };
            notifications.list[action.payload.index].isRead = true;
            --notifications.unreadCount[0].count;
            return {
                ...state,
                notifications
            }

        default:
            return state;
    }
};
